const allCountries = [
  [
    'Vietnam (Việt Nam)',
    'vn',
    '+84',
  ]
]

export default allCountries;
